/* global TimelineMax TweenMax */
import React, { Component } from 'react';

import creditTexts from '../../data/credits.json';

const propTypes = {
    open: React.PropTypes.bool.isRequired,
    width: React.PropTypes.number.isRequired,
    height: React.PropTypes.number.isRequired,
    maxWidth: React.PropTypes.number.isRequired,
};

const defaultProps = {
};

const contextTypes = {
    language: React.PropTypes.string,
};

function createMarkup(markup) {
    return { __html: markup };
}

class Credits extends Component {

    constructor(props) {
        super(props);

        this.timeline = null;
        this.container = null;
        this.flow = null;
        this.credits = null;
        this.autoscroll = null;
        this.scrollRef = null;

        this.renderCreditBlock = this.renderCreditBlock.bind(this);
    }

    componentDidMount() {
        this.animate();
    }

    componentDidUpdate(prevProps) {
        const openChanged = this.props.open !== prevProps.open;
        const sizeChanged = this.props.width !== prevProps.width ||
            this.props.height !== prevProps.height;

        if (openChanged) {
            if (this.props.open === true) {
                this.timeline.play(0);
            } else {
                this.close();
            }
        }

        if (sizeChanged) {
            this.animate();
        }
    }

    componentWillUnmount() {
        if (this.timeline !== null) {
            this.timeline.pause();
            this.timeline = null;
        }
    }

    animate() {
        if (this.timeline !== null) {
            this.timeline.pause();
        }
        this.timeline = null;

        this.timeline = new TimelineMax({
            paused: true,
        });

        this.timeline.fromTo(this.credits, 0.5, {
            height: 0,
        }, {
            height: this.props.height,
            overflow: 'hidden',
        });

        this.timeline.fromTo(this.scrollRef, 0.5, {
            'overflow-y': 'hidden',
        }, {
            'overflow-y': 'scroll',
        });

        this.timeline.fromTo(this.container, 0.5, {
            alpha: 0,
            // height: 0,
        }, {
            alpha: 1,
            // height: null,
            // paddingTop: 20,
            // paddingBottom: 20,
        });
    }

    close() {
        if (this.timeline) {
            this.timeline.stop();
            TweenMax.to(this.container, 0.5, {
                y: 0,
                alpha: 0,
                // height: 0,
                // paddingTop: 0,
                // paddingBottom: 0,
            });
            TweenMax.to(this.scrollRef, 0.3, {
                'overflow-y': 'hidden',
            });
            TweenMax.to(this.credits, 0.3, {
                height: 0,
            });
        }
    }

    renderCreditBlock(name, block) {
        const { language } = this.context;
        const title = block[`title_${language}`];
        const description = block[`description_${language}`];
        const image = block[`image_${language}`];

        return (
            <div className="top" key={name}>
                <h4 className="title">{title}</h4>
                <p className="description" dangerouslySetInnerHTML={createMarkup(description)} />
                { image ? (
                    <a href="http://www.hec.ca/" target="_blank" rel="noopener noreferrer">
                        <img className="image" src={image} alt={name} />
                    </a>
                ) : null }
                { block.items.map(item => (
                    <div className="credit-item">
                        <h4 className="subtitle">{item[`title_${language}`]}</h4>
                        { item.items.map(creditName => (
                            <p dangerouslySetInnerHTML={createMarkup(creditName)} />
                        ))}
                    </div>
                )) }
            </div>
        );
    }

    render() {
        const style = {
            margin: '0 auto',
            maxWidth: this.props.maxWidth - 40,
        };

        return (
            <div className="credits" ref={(el) => { this.credits = el; }}>
                <div className="credits-scroller" ref={(el) => { this.scrollRef = el; }}>
                    <div className="credits-container" ref={(el) => { this.container = el; }}>
                        <div style={style}>
                            { this.renderCreditBlock('creation', creditTexts.creation) }
                            { this.renderCreditBlock('onf', creditTexts.onf) }
                            { this.renderCreditBlock('thanks', creditTexts.thanks) }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Credits.propTypes = propTypes;
Credits.defaultProps = defaultProps;
Credits.contextTypes = contextTypes;

module.exports = Credits;



// WEBPACK FOOTER //
// ./js/components/partials/Credits.jsx